<template>
  <v-sheet class="pa-2" border color="grey-lighten-5" elevation="0">
    <div class="text-h6">Donation | ID. {{ donation.id }}</div>
    <div class="d-flex sm-gap">
      <v-chip variant="elevated" color="white" elevation="0" border> Montant de la donation : {{ donation.montant }}€ </v-chip>
      <v-chip variant="elevated" color="white" elevation="0" border>
        <v-icon v-if="donation.valide == '1'" icon="mdi-check" color="green-darken-4"></v-icon>
        <v-icon v-else icon="mdi-close" color="deep-orange-darken-4"></v-icon>
        Validé
      </v-chip>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["donation"],
};
</script>

<style lang="scss" scoped>
</style>